export const FIELD_TO_MANUAL_ANOMALY_COLUMN_TITLE_KEY: Record<string, string> = {
  eventDate: 'alertsManagerWidget:manualAnomalies.column.eventDate',
  eventTime: 'alertsManagerWidget:manualAnomalies.column.eventTime',
  registrationDate: 'alertsManagerWidget:manualAnomalies.column.registrationDate',
  registrationTime: 'alertsManagerWidget:manualAnomalies.column.registrationTime',
  wellboreId: 'alertsManagerWidget:manualAnomalies.column.wellboreName',
  riskLevel: 'alertsManagerWidget:manualAnomalies.column.riskLevel',
  author: 'alertsManagerWidget:manualAnomalies.column.author',
  anomalyTypeGroup: 'alertsManagerWidget:manualAnomalies.column.anomalyTypeGroup',
  anomalyTypeId: 'alertsManagerWidget:manualAnomalies.column.anomalyType',
  anomalySubtypeId: 'alertsManagerWidget:manualAnomalies.column.anomalySubtype',
  indexFormat: 'alertsManagerWidget:manualAnomalies.column.indexFormat',
  holeDepth: 'alertsManagerWidget:manualAnomalies.column.holeDepth',
  bitDepth: 'alertsManagerWidget:manualAnomalies.column.bitDepth',
  unitId: 'alertsManagerWidget:manualAnomalies.column.unit',
  valueGroup: 'alertsManagerWidget:manualAnomalies.column.valueGroup',
  limitValue: 'alertsManagerWidget:manualAnomalies.column.limitValue',
  factValue: 'alertsManagerWidget:manualAnomalies.column.factValue',
  deltaGroup: 'alertsManagerWidget:manualAnomalies.column.deltaGroup',
  deltaAbsolute: 'alertsManagerWidget:manualAnomalies.column.deltaAbsolute',
  deltaRelative: 'alertsManagerWidget:manualAnomalies.column.deltaRelative',
  notification: 'alertsManagerWidget:manualAnomalies.column.notification',
  recommendation: 'alertsManagerWidget:manualAnomalies.column.recommendation',
  stageId: 'alertsManagerWidget:contextTitle.stage',
  wellboreTypeId: 'alertsManagerWidget:contextTitle.wellboreType',
  trajectoryTypeId: 'alertsManagerWidget:contextTitle.trajectoryType',
  sectionTypeId: 'alertsManagerWidget:contextTitle.section',
  holeType: 'alertsManagerWidget:contextTitle.holeType',
  stratUnitTypeId: 'alertsManagerWidget:contextTitle.stratUnit',
  reservoirId: 'alertsManagerWidget:contextTitle.reservoir',
  runTypeId: 'alertsManagerWidget:contextTitle.run',
  operationId: 'alertsManagerWidget:contextTitle.operation',
} as const;
